export interface NewsApiArticle {
  article_id: string;
  title: string;
  link: string;
  keywords: string[];
  creator: string[];
  video_url: string | null;
  description: string;
  content: string;
  pubDate: string;
  image_url: string;
  source_id: string;
  source_priority: number;
  source_url: string;
  source_icon: string;
  language: string;
  country: string[];
  category: string[];
  ai_tag: string;
  sentiment: string;
  sentiment_stats: string;
  ai_region: string;
  ai_org: string;
  duplicate: boolean;
}

export interface NewsApiResponse {
  status: string;
  totalResults: number;
  results: NewsApiArticle[];
  nextPage: string | null;
}

export interface NewsApiParams {
  category?: string;
  q?: string;
  page?: string;
  size?: number;
  language?: string;
  lang?: string;
  country?: string;
  prioritydomain?: string;
}

const BASE_URL = (import.meta as any).env?.VITE_API_BASE_URL || '/api';

class NewsApiService {
  async fetchNews(params: NewsApiParams = {}): Promise<NewsApiResponse> {
    const qp = new URLSearchParams();
    if (params.category) qp.append('category', params.category);
    if (params.page) qp.append('page', params.page);
    if (params.lang) qp.append('lang', params.lang);
    const url = `${BASE_URL}/news?${qp.toString()}`;

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    if (data.status !== 'success') {
      throw new Error(data.message || 'API request failed');
    }
    return data;
  }

  async fetchLiteraryNews(category: string = 'Todas', page?: string, lang?: string): Promise<NewsApiResponse> {
    const params: NewsApiParams = {
      category: category !== 'Todas' ? category : undefined,
      page,
      lang,
    };
    return this.fetchNews(params);
  }
}

export const newsApiService = new NewsApiService();
